import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "has-text-right" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { computed, PropType, ref } from "vue";
import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";
import Hint from "@/components/Hint.vue";
import FilesList from "@/components/right-sidebars/content-sidebar/authoring-tool/FilesList.vue";
import { ContentStructureSection } from "@/models/content-structure.model";
import { SectionFile } from "@/models/product-section.model";
import { mdiChevronDown, mdiChevronUp, mdiPlus } from "@mdi/js";
import { useUIFilesStore } from "@/stores/ui-files.store";

const FILE_DISPLAY_LIMIT = 5;


export default /*#__PURE__*/_defineComponent({
  __name: 'Attachments',
  props: {
  section: {
    type: Object as PropType<ContentStructureSection>,
    required: true
  }
},
  emits: ["previewAttachment"],
  setup(__props, { emit: __emit }) {

const uiFilesStore = useUIFilesStore();

const emit = __emit;
const props = __props;

const filesToDisplay = computed<SectionFile[]>(() => {
  let files = [...props.section.enabled_files];
  if (files.length > FILE_DISPLAY_LIMIT && !showFullList.value) {
    return files.slice(0, FILE_DISPLAY_LIMIT);
  }
  return files;
});
const isAuthoringTool = computed<boolean>(() => {
  return props.section.type.tool_id > 0;
});

const showFullList = ref<boolean>(false);
const enableShowMoreBtn = computed<boolean>(() => {
  return props.section.enabled_files.length > FILE_DISPLAY_LIMIT;
});
const toggleFilesList = (): void => {
  showFullList.value = !showFullList.value;
};

const openFileModal = (): void => {
  uiFilesStore.openAttachFileModal({ section: props.section });
};
const previewAttachment = (fileLocation: string): void => {
  emit("previewAttachment", fileLocation);
};

return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (isAuthoringTool.value)
      ? (_openBlock(), _createBlock(RightSidebarTitle, {
          key: 0,
          title: 'Attachments'
        }, {
          default: _withCtx(() => [
            _createVNode(Hint, {
              type: 'info',
              position: 'bottom'
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("p", null, "Any files/links required for authoring this content", -1)
              ])),
              _: 1
            }),
            _createElementVNode("button", {
              class: "btn-unstyled ml-auto",
              type: "button",
              onClick: openFileModal,
              title: "Add an attachment",
              "data-testing": "sb-add-attachment-btn"
            }, [
              _createVNode(_component_SVGIcon, { path: _unref(mdiPlus) }, null, 8, ["path"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (filesToDisplay.value.length > 0)
      ? (_openBlock(), _createBlock(FilesList, {
          key: 1,
          filesToDisplay: filesToDisplay.value,
          section: __props.section,
          onPreviewAttachment: previewAttachment
        }, null, 8, ["filesToDisplay", "section"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (enableShowMoreBtn.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleFilesList()))
          }, [
            (showFullList.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  _createVNode(_component_SVGIcon, { path: _unref(mdiChevronUp) }, null, 8, ["path"]),
                  _cache[2] || (_cache[2] = _createTextVNode(" Show fewer "))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _createVNode(_component_SVGIcon, { path: _unref(mdiChevronDown) }, null, 8, ["path"]),
                  _cache[3] || (_cache[3] = _createTextVNode(" Show more "))
                ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})